import { Component, OnInit } from '@angular/core';
import { BrokerageFirm } from 'src/app/core/models/brokerage-firm';
import { Page } from 'src/app/core/models/page';
import { Subject, takeUntil } from 'rxjs';
import { SortData } from 'src/app/core/models/sort-data';
import { BrokerageFirmService } from 'src/app/core/services/brokerage-firm.service';

@Component({
  selector: 'app-summary-recommendation',
  templateUrl: './summary-recommendation.component.html',
  styleUrls: ['./summary-recommendation.component.scss']
})
export class SummaryRecommendationComponent implements OnInit {

  brokerageFirmList:BrokerageFirm[];
  page = new Page();
  sorts=new Array();
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    public brokerageFirmService: BrokerageFirmService) { }

  ngOnInit(): void {

    this.page = new Page();
      this.page.pageNumber = 1;
      this.page.size = 15;
      this.setPage(this.page);
  }

  setPage(page) {
    this.page = page;
    let sortData=new SortData<BrokerageFirm>();
    let suggestion = new BrokerageFirm();
    suggestion.lang="tr";
    suggestion.country="tr";
    suggestion.status=true;
    sortData.filter=suggestion;
    this.sorts=[{"dir": "asc", "prop": "brokerageFirm"}]
    sortData.sorts=this.sorts;
    this.page.pageNumber = this.page.pageNumber - 1;

    this.brokerageFirmService.getPageAbleList(this.page,sortData).pipe(takeUntil(this.destroy$))
    .subscribe({
      next : (pagedData) => {this.page = pagedData.page;this.brokerageFirmList = pagedData.data;},
      error : (error) => {console.log("error: ",error);}
    });
  }
  public trackByFnBrokerageFirm(index, item) {
    if (!item) return null;
    return item.id;
  }


}
